import React from 'react';
import parse from 'html-react-parser';

const FourColumnContent = ({columns}) => (
  <section className="four-column-content">
    <div className="four-column-content__inner">
      {
        columns.map((el, index) => (
          <div key={index} className="four-column-content__item">
            <h3>{el.title}</h3>

            {parse(el.content)}
          </div>))
      }
    </div>
  </section>
);

FourColumnContent.defaultProps = {
  columns: [],
};

export default FourColumnContent;